import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { listingRequestKeys } from './listingRequestQueryKeys'
import { getListingRequests } from './listingRequestEndpoints'
import { parseListingRequestList } from './listingRequestParser'
import { LISTINGS_PAGE_LIMIT } from '../constants/listingRequestLifecycle'

// One numbered page of the seller's requests — the Sell Request table's
// paginator. `keepPreviousData` holds the current rows on screen while the next
// page loads, so paging never flashes the skeleton. The dashboard preview keeps
// using the infinite `useListingRequestsQuery`.
export function useListingRequestsPageQuery(
  page: MaybeRefOrGetter<number>,
  statuses: MaybeRefOrGetter<string[]> = [],
) {
  return useQuery({
    queryKey: () => listingRequestKeys.page({ statuses: toValue(statuses) }, toValue(page)),
    queryFn: () =>
      getListingRequests({
        page: toValue(page),
        limit: LISTINGS_PAGE_LIMIT,
        statuses: toValue(statuses),
      }).then(parseListingRequestList),
    placeholderData: keepPreviousData,
  })
}
